var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"min-height-row"},[_c('v-checkbox',{staticClass:"py-0",attrs:{"indeterminate":_vm.selectionVal === 1,"hide-details":"","label":_vm.label},on:{"change":_vm.valUpdated},model:{value:(_vm.isSelected),callback:function ($$v) {_vm.isSelected=$$v},expression:"isSelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }